"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZrxApproveInfinite = void 0;
const api_1 = require("../../../api");
const erc20_abi_1 = require("../utils/abi/erc20-abi");
const constants_1 = require("../utils/constants");
const helpers_1 = require("../utils/helpers/helpers");
async function ZrxApproveInfinite({ adapterManager, web3 }, { quote, wallet }) {
    try {
        const allowanceGrantRequired = await (0, helpers_1.grantAllowance)({
            quote: {
                ...quote,
                sellAmount: constants_1.MAX_ALLOWANCE
            },
            wallet,
            adapterManager,
            erc20Abi: erc20_abi_1.erc20Abi,
            web3
        });
        return allowanceGrantRequired;
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[ZrxApproveInfinite]', {
            cause: e,
            code: api_1.SwapErrorTypes.APPROVE_INFINITE_FAILED
        });
    }
}
exports.ZrxApproveInfinite = ZrxApproveInfinite;
